// extracted by mini-css-extract-plugin
export default {"inputContainerUnique":"ArquivamentoSolic_inputContainerUnique__LPHyS","descricao":"ArquivamentoSolic_descricao__5HFBW","divPrincipal":"ArquivamentoSolic_divPrincipal__S7zug"};